import { USER_TYPES } from './profiles.enum';

export interface AssociationProfile {
  username: string;
  title?: string;
  email: string;
  isActive: boolean;
  phoneNumber?: string;
  userType: USER_TYPES;
  firstName: string;
  lastName: string;
  middleName?: string;
  suffix?: string;
  restrictNameForIndividual: boolean;
  entityId: number;
  entityName: string;
  credentialId?: string;
  mfaExpirationDate?: Date;
  regulatorCode?: string;
}

export interface ModUserProfile {
  primeUser: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  suffix?: string;
  primaryEmail: string;
  secondaryEmail?: string;
  phoneNumber?: string;
  associations: AssociationProfile[];
}

export interface ErrorResponse {
  errors: Error[];
}

export interface Error {
  message: string;
}

export function isErrorResponse(resp: any): resp is ErrorResponse {
  return 'errors' in resp || 'errorMessage' in resp || 'statusDescription' in resp;
}

export interface IndividualProfile {
  firstName: string;
  lastName: string;
  middleName: string;
  suffix: string;
  dob: Date;
  ssn: string;
  email: string;
  phoneNumber: string;
}

export interface GraphqlResponse {
  code: string;
  message: string;
}

export interface PageInfoCompanySearchResult {
  companySearchResult: [CompanySearchResult];
  pageInformation: PageInformation;
}
export enum CompanyAccess {
  Yes,
  No,
}
export interface CompanySearchResult {
  city: string;
  companyAccess: CompanyAccess;
  companyName: string;
  country: string;
  matchedNames: [string];
  nmlsId: number;
  postalCode: string;
  state: string;
  street1: string;
  street2: string;
}

export interface PageInformation {
  totalRecordsCount: number;
  currentPageNumber: number;
  currentPageSize: number;
  totalPageCount: number;
  totalRecordsOnPage: number;
}

export interface GetLicensesInput {
  subjectEntityId: number;
  licenseIds: number[];
}

export interface LicenseInfo {
  licenseId: number;
  licenseTypeCode: string;
  licenseTypeDescription: string;
  licenseStatusCode: string;
  licenseStatusCodeDescription: string;
  entityId: number;
  entityName: string;
  entityType: string;
  assigneeUsername: string;
  assigneeFirstName: string;
  assigneeLastName: string;
  openIRCount: number;
}
